import { dateToHourAndMinutes } from '@helpers/date';
import { AxfoodTimeSlotViewModel } from '@occ/api-client';
import useTranslation from 'next-translate/useTranslation';
import Text from '@atoms/Text/Text';
import {
  StyledRadio,
  StyledSlotTextInformation,
  StyledSlotTextInformationInnerWrapper,
  StyledSlotTextWrapper,
  StyledSlotTimeText,
  StyledTimeSlotItem,
} from './TimeSlot.styles';
import { useEffect, useRef } from 'react';

interface Props {
  slot: AxfoodTimeSlotViewModel;
  onClick: (slot: AxfoodTimeSlotViewModel | null) => void;
  selected: boolean;
}

const TimeSlot = ({ slot, onClick, selected }: Props) => {
  const { expressSlot, available, closeTimeFormatted } = slot;
  const { t } = useTranslation('slotSelector');
  const ref = useRef<HTMLButtonElement>(null);

  const scrollToSelectedSlot = () => {
    if (selected) {
      ref?.current?.scrollIntoView();
    }
  };

  useEffect(() => {
    scrollToSelectedSlot();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledTimeSlotItem
      type="button"
      disabled={!available && !selected}
      ref={ref}
      data-selected={selected}
      data-testid="time-slot-item"
      onClick={(e) => {
        e.preventDefault();
        if (!available) return;
        if (!selected) {
          onClick(slot);
        } else {
          onClick(null);
        }
      }}
    >
      <StyledSlotTextWrapper>
        <StyledSlotTextInformation>
          <StyledRadio
            disabled={!available && !selected}
            checked={selected}
            onChange={() => {}}
            id={slot.code}
            theme="checkmark"
            tabIndex={-1}
          />
          <StyledSlotTextInformationInnerWrapper>
            <StyledSlotTimeText
              disabled={!available && !selected}
              color={!available && !selected ? 'darkGray' : 'black'}
              type="subtitle"
              size="medium"
            >
              {`${dateToHourAndMinutes(slot.startTime)} - ${dateToHourAndMinutes(slot.endTime)}`}
            </StyledSlotTimeText>
            {expressSlot && (
              <Text type="body" size="small" color={!available ? 'darkGray' : 'black'}>
                {t('express')}
              </Text>
            )}
          </StyledSlotTextInformationInnerWrapper>
        </StyledSlotTextInformation>
        {selected && (
          <Text type="body" size="small" align="left">
            {t('changeOrder', { closeTimeFormatted })}
          </Text>
        )}
      </StyledSlotTextWrapper>
    </StyledTimeSlotItem>
  );
};

export default TimeSlot;
